import { PageHeader, Spin } from "antd";
import { TableOutlined, ClockCircleOutlined, ImportOutlined, CalculatorOutlined, RocketOutlined, AuditOutlined, SettingOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem } from "../../../Components/Items";
import TabbedDynamicTable from "../../../Components/TabbedDynamicTable";
import {
  IconStack,
  IconFall,
  IconCalendarCog,
  IconCalendar,
  IconBook,
  IconCash,
  IconFile,
} from "../../../Icons/Icons";
import TiposAcumulados from "../TiposAcumulados/TiposAcumulados";
import TiposIncidencias from "../TiposIncidencias/TiposIncidencias";
import ConfiguracionIncidenciasAsistencia from "./ConfiguracionIncidenciasAsistencia/ConfiguracionIncidenciasAsistencia";
import TipoPeriodo from "../TipoPeriodo/TipoPeriodo";
import Periodos from "../Periodos/Periodos";
import Conceptos from "../Conceptos/Conceptos";
import TipoPrestaciones from "../TipoPrestaciones/TipoPrestaciones";
import RegistroPatronal from "../RegistroPatronal/RegistroPatronal";
import Turnos from "../Turnos/Turnos";
import Tablas from "../Tablas/Tablas";
import ConfiguracionInicialWizard from "./ConfiguracionInicialWizard";
import ConfiguracionNominaContabilidad from "./ConfiguracionNominaContabilidad/ConfiguracionNominaContabilidad";
import PreferenciasNomina from "./PreferenciasNomina/PreferenciasNomina";
import VerificarContabilidadNomina from "./VerificarContabilidadNomina/VerificarContabilidadNomina";

class ConfiguracionNomina extends Component {
  state = {
    loading: true,
    configurado: false,
    // Permite volver a abrir el asistente cuando la empresa ya está configurada,
    // para dar de alta catálogos de ley que hayan quedado pendientes.
    wizardAbierto: false,
  };

  componentDidMount() {
    axios
      .post(
        "tiposPeriodos/selectTodasTiposPeriodos",
        { empresaId: this.props.empresaId, valor: 1, limit: 1, skip: 0 },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const tieneData = res.data.success === 2 && res.data.data && res.data.data.length > 0;
        this.setState({ loading: false, configurado: tieneData });
      })
      .catch(() => this.setState({ loading: false, configurado: false }));
  }

  render() {
    const { loading, configurado, wizardAbierto } = this.state;
    const mostrarWizard = !configurado || wizardAbierto;

    const tabs = [
      {
        key: "tiposAcumulados",
        label: <><IconStack size={14} marginRight={4} /> Tipos Acumulados</>,
        forceRender: false,
        customContent: <TiposAcumulados />,
      },
      {
        key: "tiposIncidencias",
        label: <><IconFall size={14} marginRight={4} /> Tipos de Incidencias</>,
        forceRender: false,
        customContent: <TiposIncidencias />,
      },
      {
        key: "incidenciasAsistencia",
        label: <><ImportOutlined style={{ marginRight: 4 }} /> Asistencia → Incidencias</>,
        forceRender: false,
        customContent: <ConfiguracionIncidenciasAsistencia />,
      },
      {
        key: "tiposPeriodos",
        label: <><IconCalendarCog size={14} marginRight={4} /> Tipos de Periodo</>,
        forceRender: false,
        customContent: <TipoPeriodo />,
      },
      {
        key: "periodos",
        label: <><IconCalendar size={14} marginRight={4} /> Periodos</>,
        forceRender: false,
        customContent: <Periodos />,
      },
      {
        key: "conceptos",
        label: <><IconBook size={14} marginRight={4} /> Conceptos</>,
        forceRender: false,
        customContent: <Conceptos />,
      },
      {
        key: "tipoPrestaciones",
        label: <><IconCash size={14} marginRight={4} /> Tipo de Prestaciones</>,
        forceRender: false,
        customContent: <TipoPrestaciones />,
      },
      {
        key: "registroPatronal",
        label: <><IconFile size={14} marginRight={4} /> Registro Patronal</>,
        forceRender: false,
        customContent: <RegistroPatronal />,
      },
      {
        key: "turnos",
        label: <><ClockCircleOutlined style={{ marginRight: 4 }} /> Turnos</>,
        forceRender: false,
        customContent: <Turnos />,
      },
      {
        key: "tablas",
        label: <><TableOutlined style={{ marginRight: 4 }} /> Tablas</>,
        forceRender: false,
        customContent: <Tablas />,
      },
      {
        key: "contabilidad",
        label: <><CalculatorOutlined style={{ marginRight: 4 }} /> Configuración General</>,
        forceRender: false,
        customContent: <ConfiguracionNominaContabilidad />,
      },
      {
        key: "preferenciasPrenomina",
        label: <><SettingOutlined style={{ marginRight: 4 }} /> Preferencias de PreNómina</>,
        forceRender: false,
        customContent: <PreferenciasNomina />,
      },
      {
        key: "verificarContabilidad",
        label: <><AuditOutlined style={{ marginRight: 4 }} /> Verificar Contabilidad</>,
        forceRender: false,
        customContent: <VerificarContabilidadNomina />,
      },
    ];

    return (
      <>
        <PageHeader
          title="Configuración Nómina"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            !loading && configurado ? (
              <ButtonItem
                icon={<RocketOutlined />}
                onClick={() => this.setState({ wizardAbierto: !wizardAbierto })}
              >
                {wizardAbierto ? "Volver a las pestañas" : "Abrir asistente de configuración"}
              </ButtonItem>
            ) : null
          }
        />
        {loading ? (
          <div style={{ backgroundColor: "white", borderRadius: 8, padding: 60, textAlign: "center" }}>
            <Spin size="large" />
          </div>
        ) : mostrarWizard ? (
          <ConfiguracionInicialWizard
            reingreso={configurado}
            onSalir={() => this.setState({ wizardAbierto: false })}
            onComplete={() => this.setState({ configurado: true, wizardAbierto: false })}
          />
        ) : (
          <div style={{ backgroundColor: "white", padding: 10, borderRadius: 8 }}>
            <TabbedDynamicTable tabs={tabs} defaultActiveKey="tiposAcumulados" />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ConfiguracionNomina);
